// react
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// hooks
import { useCareProfileForm } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';

// components
import { CareProfileFormPage } from '@karehero/llama/pwa/pages/CareProfileFormPage/CareProfileFormPage';
import { CareProfileCategoryID } from '@karehero/models';

/**
 * AttendanceAllowanceForm is the attendance allowance form page.
 */
export const AttendanceAllowanceForm = () => {
  // hooks
  const navigate = useNavigate();
  const location = useLocation();
  const goBack = useGoBack();
  const {
    progress,
    form,
    trackViewed,
    answers,
    setAnswers,
    title,
    permission,
    handleSave,
    handleCancel,
    isSubmitting,
    sections,
  } = useCareProfileForm({
    categoryID: CareProfileCategoryID.AttendanceAllowance,
  });

  // effects
  useEffect(trackViewed, [trackViewed]);

  return (
    <CareProfileFormPage
      onBack={goBack}
      title={title}
      progress={progress}
      fields={form?.fields || {}}
      value={answers}
      onChange={setAnswers}
      onSave={handleSave}
      onCancel={handleCancel}
      saveLabel='Save & Continue'
      cancelLabel='Previous'
      isDisabled={!permission.isModify}
      isLoading={isSubmitting}
      sections={sections}
      currentPath={location.pathname}
      onNavigateSection={(to) => navigate(to, { replace: true })}
    />
  );
};

export default AttendanceAllowanceForm;
